export default __webpack_public_path__ + "static/media/clark-street-merc.691225ca.jpg";